import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Euro = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M11.2978 17C11.1033 17.9596 11 18.9635 11 20C11 20.6819 11.0447 21.3497 11.1307 22H23C23.5523 22 24 22.4477 24 23C24 23.5523 23.5523 24 23 24H11.5376C13.0058 29.2855 17.3029 33 22.2025 33C24.8839 33 27.3612 31.9049 29.3097 30.0457C29.7093 29.6645 30.3422 29.6793 30.7235 30.0789C31.1048 30.4785 31.0899 31.1115 30.6903 31.4927C28.41 33.6685 25.4511 35 22.2025 35C16.0416 35 11.0055 30.2731 9.47715 24H7C6.44772 24 6 23.5523 6 23C6 22.4477 6.44772 22 7 22H9.11727C9.03988 21.3444 9 20.6767 9 20C9 18.9758 9.09137 17.9721 9.26585 17H7C6.44772 17 6 16.5523 6 16C6 15.4477 6.44772 15 7 15H9.75435C11.5514 9.23122 16.3735 5 22.2025 5C25.4511 5 28.41 6.33149 30.6903 8.50727C31.0899 8.88852 31.1048 9.52151 30.7235 9.92109C30.3422 10.3207 29.7093 10.3355 29.3097 9.95427C27.3612 8.09512 24.8839 7 22.2025 7C17.6181 7 13.5611 10.252 11.8554 15H23C23.5523 15 24 15.4477 24 16C24 16.5523 23.5523 17 23 17H11.2978Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Euro;
